import template from './sw-customer-detail-contacts.html.twig';
import './sw-customer-detail-contacts.scss';

const { Criteria } = Shopware.Data;

Component.register('sw-customer-detail-contacts', {
    template,

    inject: ['repositoryFactory'],

    props: {
        customerId: {
            type: String,
            required: true,
        },
        customer: {
            type: Object,
            required: false,
            default: null,
        },
    },

    data() {
        return {
            contacts: [],
            isLoading: false,
            showContactModal: false,
            currentContact: null,
            customerAddresses: [],
        };
    },

    computed: {
        contactRepository() {
            return this.repositoryFactory.create('tdcl_customer_contact');
        },

        customerAddressRepository() {
            return this.repositoryFactory.create('customer_address');
        },

        columns() {
            return [
                {
                    property: 'email',
                    label: this.$tc('TopdataContactLoginSW6.admin.email'),
                    rawWidth: 200,
                },
                {
                    property: 'firstName',
                    label: this.$tc('TopdataContactLoginSW6.admin.name'),
                    rawWidth: 200,
                },
                {
                    property: 'active',
                    label: this.$tc('TopdataContactLoginSW6.admin.status'),
                    rawWidth: 100,
                },
            ];
        },
    },

    watch: {
        customerId: {
            immediate: true,
            handler() {
                this.loadContacts();
                this.loadCustomerAddresses();
            },
        },
    },

    methods: {
        loadContacts() {
            if (!this.customerId) {
                return;
            }

            this.isLoading = true;

            const criteria = new Criteria();
            criteria.addFilter(Criteria.equals('customerId', this.customerId));
            criteria.addAssociation('defaultBillingAddress');
            criteria.addAssociation('defaultShippingAddress');

            this.contactRepository.search(criteria, Shopware.Context.api)
                .then((result) => {
                    this.contacts = result;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        loadCustomerAddresses() {
            if (!this.customerId) {
                return;
            }

            const criteria = new Criteria();
            criteria.addFilter(Criteria.equals('customerId', this.customerId));

            this.customerAddressRepository.search(criteria, Shopware.Context.api)
                .then((result) => {
                    this.customerAddresses = result;
                });
        },

        onAddContact() {
            this.currentContact = this.contactRepository.create(Shopware.Context.api);
            this.currentContact.customerId = this.customerId;
            this.currentContact.active = true;
            this.showContactModal = true;
        },

        onEditContact(contact) {
            this.currentContact = contact;
            this.showContactModal = true;
        },

        onDeleteContact(contact) {
            this.$refs.contactDeleteModal.showDeleteModal(contact);
        },

        onConfirmDeleteContact(contact) {
            this.isLoading = true;

            this.contactRepository.delete(contact.id, Shopware.Context.api)
                .then(() => {
                    this.loadContacts();
                    this.createNotificationSuccess({
                        message: this.$tc('TopdataContactLoginSW6.admin.contactDeleted'),
                    });
                })
                .catch(() => {
                    this.isLoading = false;
                    this.createNotificationError({
                        message: this.$tc('TopdataContactLoginSW6.admin.contactDeleteError'),
                    });
                });
        },

        onSaveContact() {
            this.isLoading = true;

            this.contactRepository.save(this.currentContact, Shopware.Context.api)
                .then(() => {
                    this.showContactModal = false;
                    this.loadContacts();
                    this.createNotificationSuccess({
                        message: this.$tc('TopdataContactLoginSW6.admin.contactSaved'),
                    });
                })
                .catch(() => {
                    this.isLoading = false;
                    this.createNotificationError({
                        message: this.$tc('TopdataContactLoginSW6.admin.contactSaveError'),
                    });
                });
        },

        onCloseModal() {
            this.showContactModal = false;
            this.currentContact = null;
        },

        getAddressLabel(address) {
            if (!address) {
                return this.$tc('TopdataContactLoginSW6.admin.noAddress');
            }
            return `${address.street}, ${address.zipcode} ${address.city}`;
        },
    },
});
